// Offers opened during this browser tab session. The click is also recorded server-side,
// but the list is restored from the local cache when the user comes back from an offer,
// so the visit has to be remembered here as well.

const KEY = "visitedOffers";
const MAX_ENTRIES = 500;

let cache: Record<string, number> | null = null;

function load(): Record<string, number> {
  if (!cache) {
    try {
      cache = JSON.parse(window.sessionStorage.getItem(KEY) || "{}");
    } catch {
      cache = {};
    }
  }
  return cache as Record<string, number>;
}

export function getOfferVisitTime(offertId: number): number | null {
  return load()[offertId] ?? null;
}

/** Forgets the visits: they belong to whoever was signed in. */
export function clearVisitedOffers(): void {
  cache = null;
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // storage unavailable - nothing was kept there either
  }
}

export function markOfferVisited(offertId: number): void {
  const visits: Record<string, number> = { ...load(), [offertId]: Date.now() };
  const ids = Object.keys(visits);
  if (ids.length > MAX_ENTRIES) {
    ids
      .sort((a, b) => visits[a] - visits[b])
      .slice(0, ids.length - MAX_ENTRIES)
      .forEach((id) => delete visits[id]);
  }
  cache = visits;
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(visits));
  } catch {
    // storage full or unavailable - the visit is still recorded server-side
  }
}
